import React from 'react';
import { Modal } from 'react-bootstrap';
import GitchaSyndicateConfirm from '../GitchaSyndicateConfirm';

const SyndicateListingModal = ({ show, onHide, syndicateListing, listing }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            className="modal-width-548">
            <Modal.Body className="signup-modal-main">
                <GitchaSyndicateConfirm
                    listing={listing}
                    onConfirm={() => syndicateListing()}
                    onCancel={() => onHide()}
                />
            </Modal.Body>
        </Modal>
    );
};

export default SyndicateListingModal;
